import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=b3ab23a0&scoped=true"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"
import style0 from "./EditModal.vue?vue&type=style&index=0&id=b3ab23a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ab23a0",
  null
  
)

export default component.exports